module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_general1_txt_m.fda684bc805bc6f1dd0959f44f393745.png";